export * from './ViewMiniIcon'
